export default "__VITE_ASSET__BAsRKgqp__"